import type { FaireProductEntity } from "../../entity_types/product";

export const p_qd762ybpy3: FaireProductEntity = {
  token: "p_qd762ybpy3",
  type: "product",
  name: "Scented Mop Soap",
  brandToken: "b_qgyqfnwdyj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/bd9f18cd42ae6da3568bbf200cc6c3ab142876708b48ec6f3f5b6e697aea986d.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.32,
  description:
    "Who says mopping has to smell boring? Our scented mop soap cleans your floors while leaving your home smelling incredible. Just a small amount in your mop water gives you powerful cleaning with a fragrance that lingers—without being overwhelming. Perfect for kitchens, bathrooms, and high-traffic areas when you want clean floors and a fresh-smelling home.",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:19.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
